export default __webpack_public_path__ + "static/media/inaccuracy.08d3f3bd.svg";